export const getAccessToken = () =>
  window.sessionStorage.getItem('accessToken');
export const getRefreshToken = () =>
  window.sessionStorage.getItem('refreshToken');

export const getTokens = () => ({
  accessToken: getAccessToken(),
  refreshToken: getRefreshToken(),
});

export const setToken = (tokens: any) => {
  window.sessionStorage.setItem('accessToken', tokens.accessToken);
  window.sessionStorage.setItem('refreshToken', tokens.refreshToken);
};

export const deleteAllTokens = () => {
  window.sessionStorage.removeItem('accessToken');
  window.sessionStorage.removeItem('refreshToken');
};

export const setLocalStorage = (name: string, value: any) =>
  window.localStorage.setItem(name, value);

export const getLocalStorage = (name: string): any =>
  window.localStorage.getItem(name);

export const removeLocalStorage = (name: string) =>
  window.localStorage.removeItem(name);

export const clearSessionStorage = () => window.sessionStorage.clear();

export const clearLocalStorage = () => window.localStorage.clear();

export const isLoggedIn = !!Number(getLocalStorage('loggedIn'));
